import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function countryReducer(state = initialState.countries, action) {
  if (action.type === types.COUNTRIES_SUCCESS) {
    return action.countries;
  } else {
    return state;
  }
}
